import { message } from "antd";
import { useEffect, useState } from "react";
import { NavLink, Route } from "react-router-dom";
import { Searchkeyword, UserRecode } from "./ajax";
import { parseStr } from "./courselistinfoph";
export function ToublePagePh(props) {
  let {
    data,
    match: { params },
    reload,
  } = props;
  const [keyword, setKeyWord] = useState({ keyword: "" });
  let json = props.location.pathname.split("/")[4];

  useEffect(() => {
    window.addEventListener("scroll", function (e) {
      document.documentElement.style.overflow = "hidden";
    });
  }, []);

  // const reload = async () => {
  //   let res = await GetAllProblemList();
  //   if (res.code !== 0) {
  //     message.error(res.message);
  //   } else {
  //     let parentArr = res.data
  //       .filter((i) => i.parentId === 0)
  //       .sort((a, b) => b.sort - a.sort);
  //     let numArr = [];
  //     parentArr.forEach((i) => {
  //       let arr = res.data
  //         .filter((j) => j.parentId === i.id)
  //         .sort((a, b) => b.sort - a.sort);
  //       numArr = [...numArr, i];
  //       arr.forEach((j) => {
  //         let narr = res.data
  //           .filter((k) => k.parentId === j.id)
  //           .sort((a, b) => b.sort - a.sort);
  //         if (narr.length) {
  //           numArr = [...numArr, j, ...narr];
  //         } else {
  //           numArr = [...numArr, j];
  //         }
  //       });
  //     });
  //     setDataList(numArr);
  //   }
  // };
  function onchange(value) {
    if (!keyword.keyword) return;
    props.history.push(`/commonproblem/search/${keyword.keyword}`);
  }
  // useEffect(() => {
  //   if (
  //     data.length &&
  //     data.filter((j) => j.id === props.match.params.id * 1).length <= 0
  //   ) {
  //     // if (window.document.body.clientWidth <= 991) {
  //     //   props.history.replace(`/commonproblem/seid/0`);
  //     // }
  //   }
  //   // props.history.replace(
  //   //   `/commonproblem/seid/${
  //   //     data.length &&
  //   //     data
  //   //       .filter((i) => i.parentId === 0)
  //   //       .filter((i) => i.showStatus === 1)[0].id
  //   //   }`
  //   // );
  // }, [data, props.match.params.id, props.history]);
  useEffect(() => {
    if (props.location.pathname.match("search")) {
      setKeyWord((state) => ({
        ...state,
        keyword:
          props.location.pathname.split("/")[
            props.location.pathname.split("/").length - 1
          ],
      }));
    } else {
      setKeyWord((state) => ({ ...state, keyword: "" }));
    }
  }, [props.location.pathname]);

  // useEffect(() => {
  //   reload();
  // }, []);

  return (
    <div className="troublepartph">
      <div className="trpubletitlenavph">
        <div className="titleph">
          <div>
            QUESTION <span>&</span> ANSWER
          </div>
          <div>问题与回答</div>
        </div>
      </div>
      <div className="troublepartcontentph">
        <div className="inputvaluestyle">
          <input
            placeholder="搜索问题"
            type="text"
            value={keyword.keyword}
            onKeyPress={onchange}
            onChange={(e) => {
              setKeyWord((state) => ({ ...state, keyword: e.target.value }));
            }}
          />
          <div className="searchiconph" onClick={onchange}></div>
        </div>
      </div>
      {/* 匹配路由的代码要一直存在*/}
      <Route
        path={`/commonproblem/seid/:id/:newId`}
        render={(p) => (
          <ThirdPart reload={reload} datalist={data} json={json} {...p} />
        )}
      />
      {/* <Route path={`/commonproblem/search/:keyword`} render={(p)=><SearchBox   data={data}  {...p}/>} /> */}

      {params.keyword ? (
        <SearchBox {...props} />
      ) : params.id * 1 === 0 ? (
        <ListDetail data={data} datalist={data} reload={reload} {...props} />
      ) : !json ? (
        <SecondPart datalist={data} reload={reload} {...props} />
      ) : (
        ""
      )}
      {/* {
                        params.keyword?<SearchBox {...props}/>:params.id*1===0?
                        <ListDetail data={data} datalist={datalist} reload={reload}/>:!json?
                        <SecondPart datalist={datalist} reload={reload}  {...props}/>:
                        <ThirdPart datalist={datalist} reload={reload} {...props} json={json}/>
                    } */}
    </div>
  );
}

function SearchBox(props) {
  const [result, setResult] = useState([]);
  useEffect(() => {
    const load = async () => {
      setResult([]);
      // props.history.replace(`/commonproblem/search/${props.match.params.keyword}`)
      let res = await Searchkeyword({ keyword: props.match.params.keyword });
      if (res.code !== 0) {
        message.error(res.message);
        return;
      } else {
        setResult(
          res.data.map((i) => {
            let Rex = new RegExp(props.match.params.keyword, "ig");
            let newTitle = i.title.replace(Rex, (value) => {
              return `<span class="keypress">${value}</span>`;
            });
            let newContent = i.content.replace(Rex, (value) => {
              return `<span class="keypress">${value}</span>`;
            });
            return { ...i, content: newContent, title: newTitle };
          })
        );
      }
    };
    load();
  }, [props.match.params.keyword]);

  return (
    <div className="searchresult">
      <div className="searchnavtitle">
        关于“<span>{props.match.params.keyword}</span>”，找到了
        <span>{result.length}</span>个相关结果
      </div>
      <div className="searchresultcontent">
        {result.map((i) => {
          return (
            <div key={i.id} className="searchresultbox">
              <div
                className="searchresultboxtitle"
                onClick={() =>
                  props.history.push(
                    `/commonproblem/seid/${i.parentId}/${i.id}`
                  )
                }
                dangerouslySetInnerHTML={{ __html: i.title }}
              ></div>
              <div
                className="searchresultboxcontent"
                onClick={() =>
                  props.history.push(
                    `/commonproblem/seid/${i.parentId}/${i.id}`
                  )
                }
                dangerouslySetInnerHTML={{ __html: i.content }}
              ></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
function ListDetail(props) {
  let { data } = props;
  return (
    <div className="navlist">
      {data
        .filter((i) => i.parentId === 0)
        .filter((i) => i.showStatus === 1)
        .map((j) => {
          return (
            <NavLink
              className="navclass"
              to={`/commonproblem/seid/${j.id}`}
              key={j.id}
            >
              <div>{j.title}</div>
            </NavLink>
          );
        })}
    </div>
  );
}
function ThirdPart(props) {
  let { json, datalist } = props;
  let id = props.match.params.id * 1;

  useEffect(() => {
    const recode = async () => {
      let res = await UserRecode({ id: props.match.params.newId });
      if (res.code !== 0) {
        message.error(res.message);
        return;
      } else {
      }
    };
    recode();
  }, [props.match.params.newId]);
  // useEffect(() => {
  //   reload();
  // }, []);

  return (
    <div className="secondpartcontent">
      <div className="biggesttitle">
        <div>
          <NavLink
            style={{ color: "#767676" }}
            to={`/commonproblem/seid/${id}`}
          >
            {datalist.length &&
              datalist.filter((i) => i.id === props.match.params.id * 1)[0]
                .title}
          </NavLink>
          /
          <span>
            {datalist.length &&
              datalist.filter((i) => i.id === json * 1)[0].title}
          </span>
        </div>
      </div>
      <div className="detaillist">
        <div className="thirdfilestyle">
          {datalist.length &&
            datalist.filter((i) => i.id === json * 1)[0].title}
        </div>
        <div className="text">
          <RenderHtml3
            flow={"100%"}
            state={{
              content:
                datalist.length &&
                datalist.filter((i) => i.id === json * 1)[0].content,
            }}
          />
        </div>
      </div>
    </div>
  );
}
function SecondPart(props) {
  let { datalist } = props;
  const [active, setActive] = useState([]);
  return (
    <div className="secondpartcontent">
      <div className="biggesttitle">
        {datalist.length &&
          datalist.filter((i) => i.id === props.match.params.id * 1)[0]?.title}
      </div>
      <div className="detaillist">
        {datalist
          .filter(
            (i) =>
              i.parentId === props.match.params.id * 1 && i.showStatus === 1
          )
          .map((i) => {
            return (
              <div className="secondnav" key={i.id}>
                <div className="secondnavtitlestyle">{i.title}</div>
                <div className="thirdnavbox">
                  {datalist
                    .filter((j) => j.parentId === i.id && i.showStatus === 1)
                    .map((k) => {
                      return (
                        <div key={k.id}>
                          <div className="thirdnavtitle">
                            <div
                              onClick={() => {
                                setActive((arr) => {
                                  let index = arr.indexOf(k.id);
                                  if (index !== -1) {
                                    arr.splice(index, 1);
                                  } else {
                                    arr.push(k.id);
                                  }
                                  return [...arr];
                                });
                              }}
                            >
                              {k.title}
                            </div>
                            <div>
                              <div
                                style={{
                                  marginTop: "0.05rem",
                                  marginLeft: "0.45rem",
                                  paddingRight: "0.8rem",
                                }}
                              >
                                {active.indexOf(k.id) !== -1 ? (
                                  <div>
                                    <RenderHtml3
                                      flow={"100%"}
                                      state={{ content: k.content }}
                                    />
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

// function parseStr2(str=''){
//     return str.replace(/font-size:.*?(?=px)/g,(value)=>{
//         let newValue = Math.ceil(parseInt(value.replace(/font-size:/g,''))/1.7)
//         return `font-size:${newValue}`
//     })
// }
// function parseStr(str = '') {

//   return str.replace(/font-size:.*?(?=px)|width=".*?(?=px")|height=".*?(?=px")|height:.*?(?=px)|width:.*?(?=px)/g, (value) => {

//     let newValue = Math.ceil(parseInt(value.replace(/font-size:|width="|height="|height:|width:/g, '')) / 1.7)
//     let arr = value.split(/\d/)
//     return arr[0] + newValue

//   })
// }
export const RenderHtml3 = (props) => {
  let {
    state: { content: __html },
    dom,
    flow,
  } = props;

  return (
    <pre
      id="prevs"
      style={{
        lineHeight: "1.5",
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
        overflow: "hidden",
        maxWidth: flow,
        fontFamily: `SourseHanSansCN-Regular,Metrosant-Regular,SourseHanSansCN-Medium,SourceHanSansCN-Bold,SourceHanSansCN-Heavy,SourceHanSansCN-Light,SourceHanSansCN-Normal,SourceHanSansCN-ExtraLight`,
      }}
    >
      <div
        className="braft-output-content"
        style={{ width: "100%" }}
        ref={dom}
        dangerouslySetInnerHTML={{ __html: parseStr(__html ? __html : "") }}
      ></div>
    </pre>
  );
};
